import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import type { AxiosResponse } from 'axios';
import { axiosInstance } from '@shared/lib/axios';
import type { TAxiosError } from '@shared/lib';
import { QUERIES_INFO, MUTATIONS_INFO } from '@shared/lib/const';
type TUseImpersonateRequestPayload = {
  uuid: string;
};
type TUseImpersonateResponse = {
  message: string;
  status: string;
};
export type TUseImpersonateParams = {
  options?: UseMutationOptions<AxiosResponse<TUseImpersonateResponse>, unknown, TUseImpersonateRequestPayload>;
};
export const useImpersonate = ({
  options
}: TUseImpersonateParams = {}) => {
  const queryClient = useQueryClient();
  return useMutation<AxiosResponse<TUseImpersonateResponse>, TAxiosError, TUseImpersonateRequestPayload>(params => axiosInstance.post<TUseImpersonateResponse, AxiosResponse<TUseImpersonateResponse>, TUseImpersonateRequestPayload>(MUTATIONS_INFO.impersonation, params), {
    ...options,
    onSuccess: async () => {
      queryClient.invalidateQueries(QUERIES_INFO.currentUser.key);
    }
  });
};